export default __webpack_public_path__ + "static/media/roy-team.4363f2f2.svg";